import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { FILE_UPLOAD_CONFIG, PRODUCT_CONFIG, RenewalData, RENEWAL_MSGS } from 'src/app/_common/product-config';
import { US_STATES } from 'src/app/_common/us-states';
import { RenewalPolicyOptionsValue, RenewalPolicyOptions, DoNotRenewalPolicyReasons, DiceExposuresMediaTypes, LocationType, CompanyLegalNameUpdateReason, AccountAddressType, DocumentFileType, LOBType, YesNo, LOBTypeFullName, CustomInputType, AddressType, ContactRoleType, RenewalType, YesNoValue } from 'src/app/_common/_enum/module.enum';
import { HeaderData } from 'src/app/_models/header-data';
import { AuditContact, BillingContact, LocationObject, Renewal, RenewalMethods } from '../../_models/start-renewal';
import { RenewalsService } from '../../_services/renewals.service';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-start-renewal-basic-info',
  templateUrl: './start-renewal-basic-info.component.html',
  styleUrls: ['./start-renewal-basic-info.component.scss']
})
export class StartRenewalBasicInfoComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData: HeaderData;
  private renewalBasicInfo: Renewal;
  private RenewalPolicyOptionsValue = RenewalPolicyOptionsValue;
  private RenewalPolicyOptions = RenewalPolicyOptions;
  private DoNotRenewalPolicyReasons = DoNotRenewalPolicyReasons;
  private CompanyLegalNameUpdateReason = CompanyLegalNameUpdateReason;
  private AccountAddressType = AccountAddressType;
  private documentFileTypeEnum = DocumentFileType;
  private AddressType = AddressType;
  private LOBTypeFullName = LOBTypeFullName;
  private RenewalBasicInfoData = RenewalData;
  private YesNoEnum = YesNo;
  private YesNoValueEnum = YesNoValue;    //Using it in HTML
  private customInputTypes = CustomInputType;
  private renewalMethods:RenewalMethods = new RenewalMethods();

  private productConfig = PRODUCT_CONFIG;
  private fileUploadConfig = FILE_UPLOAD_CONFIG;
  private renewalMsgs = RENEWAL_MSGS;
  private USAStates = US_STATES;

  private uploadedFileSize: number = 0;
  private attachmentError: string = "";

  private accountNumber;
  private renewalNumber;
  private renewalAccountData;
  private renewalData;
  private addressChangeObj;
  private contactChangeObj;
  private supportingDocuments = [];
  private effectiveMinDate;

  private accountCompanyData = null;

  private loading: boolean = false;
  private apiLoading: boolean = false;
  private isSubmitted: boolean = false;
  private isMediaTypeOtherSelected: boolean = false;
  private anyNewExposureOrChanges: boolean = false;

  private isCompanySubmitted: boolean = false;
  private isAddressSubmitted: boolean = false;
  private isContactSubmitted: boolean = false;

  private DONOT_RENEW_REASON;
  private DICE_EXPOSURES_MEDIA_TYPES;
  private COMPANY_NAME_REASONS;

  @Output() attachFileSize = new EventEmitter<any>();

  @ViewChild("basicInfoForm", { static: false }) basicInfoForm: NgForm;
  @ViewChild("companyNameModal", { static: false }) companyNameModal;
  @ViewChild("addressChangeModal", { static: false }) addressChangeModal;
  @ViewChild("contactChangeModal", { static: false }) contactChangeModal;
  @ViewChild('renewingPolicies', {static: false}) renewingPolicies;
  @ViewChild('attachments', {static: false}) attachments;
  
  constructor(private route: ActivatedRoute, private router: Router, private el: ElementRef, private renewalsService: RenewalsService, private commonService: CommonService, private formatter: NgbDateParserFormatter) { }

  ngOnInit() {
    this.renewalBasicInfo = this.getRenewal();
    this.renewalData = this.renewalBasicInfo.renewalData;

     /* Setting Headers Starts */
      this.headerData = new HeaderData();
      this.setHeaderData();
    /* Setting Headers Ended */

    if(!this.renewalBasicInfo.fromReview){
      this.fetchRenewalsLookupData();
    } else {
      this.DICE_EXPOSURES_MEDIA_TYPES = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.DICE_EXPOSURES_MEDIA_TYPES));
      this.DONOT_RENEW_REASON = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.DONOT_RENEW_REASON));
      this.COMPANY_NAME_REASONS = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.COMPANY_NAME_REASONS));
      
      this.DICE_EXPOSURES_MEDIA_TYPES.forEach(_type => {
        _type.isSelected = (this.renewalData.diceExposure.mediaTypes.indexOf(_type.mediaName) > -1);
      });

      this.isMediaTypeOtherSelected = this.DICE_EXPOSURES_MEDIA_TYPES.findIndex(_type => _type.mediaName == DoNotRenewalPolicyReasons.OTHER && _type.isSelected) > -1;
      
      /* this.renewalData.diceExposure.mediaType = [];
      this.renewalData.diceExposure.mediaType = this.DICE_EXPOSURES_MEDIA_TYPES.filter(_type =>_type.isSelected).flatMap(_type => _type.mediaName);; */
    }
      this.COMPANY_NAME_REASONS = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.COMPANY_NAME_REASONS));

    //Getting Renewal Number for State params
    this.route.paramMap.subscribe(params => {
      this.renewalNumber = params.get("id").toString();
    });

    this.renewalData.renewalNumber = this.renewalNumber;
    
    console.log(this.renewalBasicInfo);

    this.renewalAccountData = this.renewalsService.getRenewalAccountData();
    if ((!this.renewalAccountData || !this.renewalAccountData.data) || this.renewalAccountData.data.renewalNumber != this.renewalNumber) {
      this.router.navigateByUrl("renewals/" + this.renewalNumber +"/"+this.renewalAccountData.data.accountNumber + "/manage");
    }
    if(!this.renewalBasicInfo.fromReview){
      this.startRenewal();
    }
    
    let _effectiveMinDate = new Date();
    this.effectiveMinDate =  {year: _effectiveMinDate.getFullYear(), month: _effectiveMinDate.getMonth()+1, day: _effectiveMinDate.getDate()};

    this.supportingDocuments = this.renewalsService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    this.supportingDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
  }

  setHeaderData(){
    this.headerData.pageTitle = "Start Renewal";

    this.renewalsService.header = this.headerData;
  }
  fetchRenewalsLookupData() {
    this.renewalsService.fetchRenewalsLookupData().subscribe((_data: any) => {
      if(_data.media){
        this.RenewalBasicInfoData.DICE_EXPOSURES_MEDIA_TYPES = _data.media.map((_type, _index) => {return { "id": _index+1, "type": _type.displayName, "mediaId": _type.mediaId, "mediaName": _type.mediaName,"displayName": _type.displayName, "isSelected": false }});
        this.RenewalBasicInfoData.DICE_EXPOSURES_MEDIA_TYPES.push({ "id": _data.media.length+1, "type": DoNotRenewalPolicyReasons.OTHER, mediaId: DoNotRenewalPolicyReasons.OTHER, mediaName: DoNotRenewalPolicyReasons.OTHER, displayName: DoNotRenewalPolicyReasons.OTHER, "isSelected": false });
      } 
      this.DICE_EXPOSURES_MEDIA_TYPES = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.DICE_EXPOSURES_MEDIA_TYPES));

      if (_data.doNotRenewReason) {
        this.RenewalBasicInfoData.DONOT_RENEW_REASON = _data.doNotRenewReason.map((_reason, _index) => {return { "id":  _index+1, "type": _reason, "displayName": _reason, "isSelected": false }});
      }
      this.DONOT_RENEW_REASON = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.DONOT_RENEW_REASON));
      console.log('this.DONOT_RENEW_REASON :: ', this.DONOT_RENEW_REASON);
    });
  }
  
  get isAPILoaded(): boolean{
    return !this.apiLoading;
  }
  
  startRenewal() {
    this.loading = true;
    this.apiLoading = true;
    this.renewalsService.initRenewalData(RenewalType.START, this.renewalAccountData.data).subscribe((_data: any) => {
      this.loading = false;
      this.apiLoading = false;
      console.log(_data);
      this.renewalData.account.accountNumber = _data.accountNumber;
      this.renewalData.account.originalName = _data.accountName;
      this.renewalData.account.requestedName = JSON.parse(JSON.stringify(_data.accountName));
      
      if (!_data.addresses.find(_address => _address.addressType == AddressType.Mailing)) {
        let _add = this.renewalMethods.newLocationObject(new LocationObject());
        _add.addressType = AddressType.Mailing;
        _data.addresses.push(_add);
      }
      if (!_data.addresses.find(_address => _address.addressType == AddressType.Billing)) {
        let _add = this.renewalMethods.newLocationObject(new LocationObject());
        _add.addressType = AddressType.Billing;
        _data.addresses.push(_add);
      }

      _data.addresses.forEach(_address => {
        if (_address.addressType == AddressType.Business) {
          _address.id = 0;
        } else if (_address.addressType == AddressType.Mailing) {
          _address.id = 1;
        } else if (_address.addressType == AddressType.Billing) {
          _address.id = 2;
        }
      });
      _data.addresses.sort((a, b) => a.id > b.id ? 1 : -1);
      
      _data.addresses.forEach(_address => {
        let newAddress = this.renewalMethods.newLocationObject(_address);
        this.renewalData.address.original.push(newAddress);
        this.renewalData.address.requested.push(JSON.parse(JSON.stringify(newAddress)));
      });
      

      if (_data.contacts && _data.contacts.length > 0) {
        _data.contacts.map(_contact => { if (!_contact.companyName) { _contact.companyName = '' } });
        this.renewalData.contacts.original = _data.contacts;
        if (!this.renewalData.contacts.original.find(_contact => _contact.roleName == ContactRoleType.Audit)) {
          this.renewalData.contacts.original.splice(0,0,new AuditContact());
        }
        if (!this.renewalData.contacts.original.find(_contact => _contact.roleName == ContactRoleType.Billing)) {
          this.renewalData.contacts.original.push(new BillingContact());
        }
        this.renewalData.contacts.requested = JSON.parse(JSON.stringify(this.renewalData.contacts.original));
      } else {
        this.renewalData.contacts.original = [new AuditContact(), new BillingContact()];
        this.renewalData.contacts.requested = [new AuditContact(), new BillingContact()]
      }
      this.generateRenewingPolicies(_data.renewingPolicies);
    }, error => {
      this.loading = false;
      this.apiLoading = false;
    });
  }

  get RenewalData() {
    return this.renewalData;
  }

  getAddressLabel(_addressType) {
    if (_addressType == LocationType.PRIMARY_LABEL || _addressType == LocationType.BUSINESS_LABEL) {
      return LocationType.PRIMARY;
    }else if (_addressType == LocationType.MAILING_LABEL) {
      return LocationType.MAILING_ADDRESS;
    }else if (_addressType == LocationType.BILLING_LABEL) {
      return LocationType.BILLING_ADDRESS;
    } else {
      return _addressType;
    }
  }

  setFileIcon(file: any){
    return this.commonService.setFileIcon(file);
  }

  generateRenewingPolicies(_policies) {
    _policies.forEach(_policy => {
      _policy.doNotRenewReason = '';
      _policy.renewOption = null;
      _policy.changeRequestDesc = null;
      _policy.otherRemarks = '';
      _policy.customLobCode = _policy.lobCode;

      if (_policy.lobCode == LOBType.Umbrella || _policy.lobCode == LOBType.Excess) {
        _policy.customLobCode = LOBType.Excess_Umbrella;
      }
      this.renewalData.renewingPolicies.push(_policy);      
    });
    this.renewalData.renewingPolicies.sort((a, b) =>  (b.isPrimaryLine - a.isPrimaryLine));
    console.log(this.renewalData.renewingPolicies);
  }

  onSelectPolicyOption(_policy, _option) {
    _policy.renewOption = _option;
    _policy.doNotRenewReason = '';

    if (_policy.isPrimaryLine && _option == RenewalPolicyOptionsValue.DO_NOT_RENEW) {
      this.renewalData.renewingPolicies.forEach(__policy => {
        if(!__policy.isPrimaryLine && __policy.renewOption == RenewalPolicyOptionsValue.RENEW){
          __policy.renewOption = '';

            let ind = this.renewalData.exposures.findIndex(_exposureObj => _exposureObj.lobName.toLowerCase() == __policy.productName.toLowerCase());
            if (ind > -1){ //this.renewalBasicInfo.EXPOSURES.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase()))
              this.renewalData.exposures.splice(ind, 1);
            }else{
              ind = this.renewalData.exposures.findIndex(_exposureObj => _exposureObj.name.toLowerCase() == __policy.customLobCode.toLowerCase());
              if (ind > -1){ //this.renewalBasicInfo.EXPOSURES.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase()))
                this.renewalData.exposures.splice(ind, 1);
              }
            }
        }
      });
    }

    if (_option == RenewalPolicyOptionsValue.RENEW) {
      if (!this.renewalData.exposures.find(_exposureObj => _exposureObj.name.toLowerCase() == (LOBType.Common.toLowerCase()))){
        this.renewalData.exposures.push(JSON.parse(JSON.stringify(this.RenewalBasicInfoData.EXPOSURES.find(_exposureObj => _exposureObj.name.toLowerCase() == LOBType.Common.toLowerCase()))));
      }
      
      if (_policy.lobs && _policy.lobs.length > 0) {
        _policy.lobs.forEach(_lob => {
          if (!this.renewalData.exposures.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase())) && this.RenewalBasicInfoData.EXPOSURES.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase()))){
            this.renewalData.exposures.push(JSON.parse(JSON.stringify(this.RenewalBasicInfoData.EXPOSURES.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase())))));
          }
        });
      } else {        
        if (!this.renewalData.exposures.find(_exposureObj => _exposureObj.name.toLowerCase() == (_policy.customLobCode.toLowerCase())) && this.RenewalBasicInfoData.EXPOSURES.find(_exposureObj => _exposureObj.name.toLowerCase() == (_policy.customLobCode.toLowerCase()))){
          this.renewalData.exposures.push(JSON.parse(JSON.stringify(this.RenewalBasicInfoData.EXPOSURES.find(_exposureObj => _exposureObj.name.toLowerCase() == (_policy.customLobCode.toLowerCase())))));
        }
      }
    } else {
      if (!this.hasRenewingPolicies()) {
        this.renewalData = JSON.parse(JSON.stringify(this.renewalMethods.resetRenewalForm(this.renewalData)));
        this.renewalsService.setSupportingDocuments([]);
        this.supportingDocuments = [];
        this.isMediaTypeOtherSelected = false;
        this.DICE_EXPOSURES_MEDIA_TYPES = JSON.parse(JSON.stringify(this.RenewalBasicInfoData.DICE_EXPOSURES_MEDIA_TYPES));
      }
      if (_policy.lobs && _policy.lobs.length > 0) {
        _policy.lobs.forEach(_lob => {
          let ind = this.renewalData.exposures.findIndex(_exposureObj => _exposureObj.lobName.toLowerCase() == _lob.toLowerCase());
          if (ind > -1){ //this.renewalBasicInfo.EXPOSURES.find(_exposureObj => _exposureObj.lobName.toLowerCase() == (_lob.toLowerCase()))
            this.renewalData.exposures.splice(ind, 1);
          }
        });
      }
    }

    this.scrollToExposures();
  }

  scrollToExposures() {
    window.setTimeout(()=>{
      window.setTimeout(()=>{
      (this.renewingPolicies.nativeElement as HTMLElement).scrollIntoView({behavior:"smooth"});
      },100);
    }, 50);
  }

  onSelectOption($value, _option) {
    console.log($value);
    _option.isSelected = $value;
  }

  hasRenewingPolicies() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.renewOption == RenewalPolicyOptionsValue.RENEW);
  }

  isPrimaryLineNotRenewing() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.isPrimaryLine == true && _policy.renewOption == RenewalPolicyOptionsValue.DO_NOT_RENEW);
  }

  get isRenewingExcessPolicies() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.lobCode == LOBType.Excess && _policy.renewOption == RenewalPolicyOptionsValue.RENEW);
  }
  
  get isRenewingUMPolicies() {
    return this.renewalData.renewingPolicies.find(_policy => _policy.lobCode == LOBType.Umbrella && _policy.renewOption == RenewalPolicyOptionsValue.RENEW);
  }
  onSelectMediaType(mediaType) {
    let index = this.renewalData.diceExposure.mediaTypes.indexOf(mediaType.displayName);
    if (index>-1) {
      this.renewalData.diceExposure.mediaTypes.splice(index, 1);
      if((mediaType.displayName.toLowerCase() === DiceExposuresMediaTypes.OTHER)){
        this.isMediaTypeOtherSelected = false;
        this.renewalData.diceExposure.additionalInfo = '';
      }
    } else {
      this.renewalData.diceExposure.mediaTypes.push(mediaType.displayName);
      if((mediaType.displayName.toLowerCase() === DiceExposuresMediaTypes.OTHER)){
        this.isMediaTypeOtherSelected = true;
        this.renewalData.diceExposure.additionalInfo = '';
      }
    }
    this.renewalData.diceExposure.mediaTypes.sort();
    let ind = this.renewalData.diceExposure.mediaTypes.findIndex(_mediaType => _mediaType.toLowerCase() == DiceExposuresMediaTypes.OTHER);
    //this.renewalData.diceExposure.mediaTypes.push(this.renewalData.diceExposure.mediaTypes.splice(ind, 1));
    if(ind > -1)
      this.renewalData.diceExposure.mediaTypes.splice(this.renewalData.diceExposure.mediaTypes.length-1, 0, this.renewalData.diceExposure.mediaTypes.splice(ind, 1)[0]);
  }

  onNeedByDateSelect(_event){
    if (_event == null) {
      this.renewalData.quoteNeedByDate = this.formatter.format(this.formatter.parse(this.basicInfoForm["needByDate"]));
    } else {
      this.renewalData.noQuoteNeeded = false;
      this.renewalData.quoteNeedByDate = this.formatter.format(_event); //new Date(this.formatter.format(_event));//new Date(_event.year, _event.month-1, _event.day);
    }
  }

  noQuoteNeededChange(_event) {
    if(_event.target.value){
      this.renewalData.quoteNeedByDate = null;
    }
  }

  get commonExposures(): any {
    return this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Common).options;
  }

  get hasAuExposures(): any {
    return this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Automobile);
  }
  get auExposureOptions(): any {
    return this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Automobile).options;
  }

  get hasExUmExposures(): any {
    return this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Excess_Umbrella);
  }
  get exUmExposureOptions(): any {
    return this.renewalData.exposures.find(_exposure => _exposure.name == LOBType.Excess_Umbrella).options;
  }

  resetAUExposureOptions(_auDoesNotApplicable) {
    if (_auDoesNotApplicable) {
      this.auExposureOptions.forEach(_auExposure => {
        if (_auExposure.keyValueID != "1") {
          _auExposure.value = null;
          _auExposure.doesNotApplicable = false;
        }
      });
    }
  }

  doesNotApplicable(_doesNotApplicable, _exposureOption) {
    if (_doesNotApplicable) {
      _exposureOption.value = null;
    }
  }

  getRenewal(){
    return this.renewalsService.renewal;
  }

  trimText(_text) {
    return (_text)?_text.trim():"";
  }

  getAddresses() {
    if (this.renewalData.accountAddresses.find(_address => _address.type == AccountAddressType.CURRENT)) {
      return this.renewalData.accountAddresses.find(_address => _address.type == AccountAddressType.CURRENT).addresses;
    }

    return this.renewalData.accountAddresses.find(_address => _address.type == AccountAddressType.ORIGINAL).addresses;
  }

  openCompanyNameModal(){
    this.isCompanySubmitted = false;
    this.accountCompanyData = JSON.parse(JSON.stringify(this.renewalData.account));
    this.renewalsService.openModal('none', this.companyNameModal, false, '', 'static' , 'company-name-modal', 'lg', true);
  }
  closeCompanyNameModal(_form, _modal, _reason) {
    _form.reset(this.renewalData.account)
    _modal.dismiss(_reason);
  }
  saveCompanyName(_form, _company, _modal) {
    this.isCompanySubmitted = true;
    if (_form.valid) {
      this.renewalData.account = this.accountCompanyData;

      if (this.renewalData.account.originalName != this.trimText(this.renewalData.account.requestedName)) {
        _company.isEdited = true;
        _modal.close();
      }
    }
  }

  openAddressChangeModal(address, isAdding = false) {
    this.isAddressSubmitted = false;
    this.addressChangeObj = JSON.parse(JSON.stringify(address));
    this.addressChangeObj.isAdding = isAdding;
    this.renewalsService.openModal('none', this.addressChangeModal, false, '', 'static' , 'address-change-modal', 'lg', true);
  }
  closeAddressChangeModal(_form, _modal, _reason) {
    _form.resetForm();
    this.addressChangeObj = null;
    _modal.dismiss(_reason);
  }
  saveAddressModal(_form, _address, _modal) {
    this.isAddressSubmitted = true;
    if (_form.valid) {
      delete _address.isAdding;
      if (_address.applyToAnotherAddress && _address.addressType == AddressType.Mailing) {
        delete _address.applyToAnotherAddress;
        
        let _oldAdd = this.renewalData.address.requested.find(_a => _a.addressType == AddressType.Billing);
        let ind = this.renewalData.address.requested.findIndex(_a => _a.addressType == AddressType.Billing);
        let _newAdd = JSON.parse(JSON.stringify(_address));
        _newAdd.addressType = AddressType.Billing;
        if(!_oldAdd.isEdited)
          _newAdd.isEdited = (JSON.stringify(_oldAdd) != JSON.stringify(_newAdd));
        this.renewalData.address.requested[ind] = _newAdd;
      }else if (_address.applyToAnotherAddress && _address.addressType == AddressType.Billing) {
        delete _address.applyToAnotherAddress;
        
        let _oldAdd = this.renewalData.address.requested.find(_a => _a.addressType == AddressType.Mailing);
        let ind = this.renewalData.address.requested.findIndex(_a => _a.addressType == AddressType.Mailing);
        let _newAdd = JSON.parse(JSON.stringify(_address));
        _newAdd.addressType = AddressType.Mailing;
        if(!_oldAdd.isEdited)
          _newAdd.isEdited = (JSON.stringify(_oldAdd) != JSON.stringify(_newAdd));
        this.renewalData.address.requested[ind] = _newAdd;
      }
      if (JSON.stringify(_address) != JSON.stringify(this.renewalData.address.requested.find(__address => __address.addressType == _address.addressType))) {
        _address.isEdited = true;
        let ind = this.renewalData.address.requested.findIndex(__address => __address.addressType == _address.addressType);
        this.renewalData.address.requested[ind] = _address;
      }
      console.log(this.renewalData.address.requested);
      _modal.close();
    }
  }

  openContactChangeModal(contact, isAdding = false) {
    this.isContactSubmitted = false;
    this.contactChangeObj = JSON.parse(JSON.stringify(contact));
    this.contactChangeObj.isAdding = isAdding;
    this.renewalsService.openModal('none', this.contactChangeModal, false, '', 'static' , 'address-change-modal', 'lg', true);
  }
  closeContactChangeModal(_form, _modal, _reason) {
    _form.resetForm();
    this.contactChangeObj = null;
    _modal.dismiss(_reason);
  }
  saveContact(_form, _contact, _modal) {
    this.isContactSubmitted = true;
    if (_form.valid) {
      delete _contact.isAdding;
      if (JSON.stringify(_contact) != JSON.stringify(this.renewalData.contacts.requested.find(__contact => __contact.roleName == _contact.roleName))) {
        _contact.isEdited = true;
        let ind = this.renewalData.contacts.requested.findIndex(__contact => __contact.roleName == _contact.roleName);
        this.renewalData.contacts.requested[ind] = _contact;
      }
      console.log(this.renewalData.contacts.requested);
      _modal.close();
    }
  }

  fileBrowseHandler(files) {
    this.uploadAllDocuments(files, this.documentFileTypeEnum.Other);
  }

  uploadAllDocuments(files, _docFileType=this.documentFileTypeEnum.Other){
    if(files.currentTarget && files.currentTarget.files){
      files = files.currentTarget.files;
    }

    if (files.length == 0) {
      console.log("No file selected!");
      return;
    }

    let allDocuments = this.renewalsService.getSupportingDocuments();
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });

    this.attachmentError = null;
    Array.from(files).forEach((_file:any)=>{
      _file.docFileType = _docFileType;
      _file.uniqueName = (Math.random() * 1000000000).toFixed(0);
      if(_file.size>0 && (this.uploadedFileSize+(Number(_file.size)))<this.fileUploadConfig.MaxUploadSize){
        this.uploadedFileSize+=(Number(_file.size));
        this.renewalsService.addSupportingDocument(_file);  
      }else if(_file.size == 0){
        this.attachmentError = this.fileUploadConfig.AttachmentNoContent;
        console.log("File has no content");
      }else{
        this.attachmentError = this.fileUploadConfig.AttachmentExceeds;
        console.log("File size exceeding");
      }
    });
     
    window.setTimeout(()=>{
      window.setTimeout(()=>{
      (this.attachments.nativeElement as HTMLElement).scrollIntoView({behavior:"smooth"});
      },100);
    }, 50);

    this.attachFileSize.emit(this.uploadedFileSize);
    this.supportingDocuments = this.renewalsService.getSupportingDocuments();
  }

  removeDocument( _docFileType, _uniqueName){
    let allDocuments = this.renewalsService.getSupportingDocuments();
    let fileIndex = allDocuments.findIndex(_docFile=>{return _docFile.uniqueName == _uniqueName});
    this.renewalsService.getSupportingDocuments().splice(fileIndex, 1);
    
    this.uploadedFileSize = 0;
    allDocuments.forEach(document=>{
      this.uploadedFileSize += (Number(document.size));
    });
    this.attachFileSize.emit(this.uploadedFileSize);
    this.attachmentError = null;
  }

  getSupportingDocuments(_docFileType){
    let docFiles = this.renewalsService.getSupportingDocuments().filter(_docFile=>{return _docFile.docFileType == _docFileType});

    return docFiles;
  }

  get hasNewExposureOrExposureChanged() {
    return this.commonExposures.find(_exposure => _exposure.value == this.YesNoEnum.YES);
  }
  get hasExcessIncluded() {
    return this.exUmExposureOptions.find(_exposure => _exposure.value == this.YesNoEnum.YES);
  }

  onContinue():boolean{  
    // remove renewalPolicy decline reason if changes in decision.
    // remove exposure added and changes reason if changes in decision.

    this.isSubmitted = true;
    const formGroupInvalid = this.el.nativeElement.querySelectorAll('.ng-invalid:not(form)');
    if(formGroupInvalid.length>0){
      (<HTMLInputElement>formGroupInvalid[0]).focus();
      return;
    }

    this.renewalBasicInfo.renewalData = this.renewalData;

    this.renewalsService.storeRenewalData(this.renewalBasicInfo);

    return (this.basicInfoForm.valid);
  }
}
